import { useEffect, useRef, useState } from 'react';

const galleryItems = [
  {
    id: 1,
    src: 'https://public.readdy.ai/ai/img_res/9b338fbe68945922cbc12e04415ba01a.jpg',
    category: 'Bridal',
    tall: true,
  },
  {
    id: 2,
    src: 'https://readdy.ai/api/search-image?query=Lush%20wedding%20table%20centerpiece%20with%20white%20and%20blush%20garden%20roses%20peonies%20and%20greenery%20in%20a%20glass%20vase%2C%20elegant%20reception%20table%20setting%20with%20candles%20and%20soft%20linens%2C%20luxury%20wedding%20floral%20decor%20photography%2C%20warm%20golden%20candlelight&width=700&height=500&seq=bloom-gallery-2&orientation=landscape',
    category: 'Wedding',
    tall: false,
  },
  {
    id: 3,
    src: 'https://readdy.ai/api/search-image?query=Bridal%20bouquet%20held%20by%20bride%20in%20white%20wedding%20dress%2C%20cascading%20bouquet%20of%20pink%20garden%20roses%20ranunculus%20and%20eucalyptus%20greenery%2C%20romantic%20outdoor%20ceremony%2C%20golden%20afternoon%20sunlight%20filtering%20through%20trees%2C%20soft%20bokeh%20background%2C%20love%20and%20elegance&width=600&height=750&seq=bloom-gallery-3&orientation=portrait',
    category: 'Bridal',
    tall: true,
  },
  {
    id: 4,
    src: 'https://readdy.ai/api/search-image?query=Elegant%20dried%20flower%20wreath%20with%20pampas%20grass%20dried%20roses%20neutral%20beige%20and%20terracotta%20tones%20mounted%20on%20white%20wall%2C%20hygge%20home%20decor%2C%20warm%20lifestyle%20photography%2C%20minimal%20and%20natural%20aesthetic%2C%20overhead%20flat%20lay%20style&width=700&height=500&seq=bloom-gallery-4&orientation=landscape',
    category: 'Interior',
    tall: false,
  },
  {
    id: 5,
    src: 'https://readdy.ai/api/search-image?query=Gift%20flower%20bouquet%20wrapped%20in%20white%20paper%20with%20nude%20satin%20ribbon%2C%20fresh%20cut%20roses%20coral%20and%20peach%20tones%2C%20minimalist%20elegant%20packaging%2C%20boutique%20florist%2C%20white%20background%20with%20soft%20shadows%2C%20luxury%20gift%20giving%20concept%20photography&width=600&height=700&seq=bloom-gallery-5&orientation=portrait',
    category: 'Gift',
    tall: false,
  },
  {
    id: 6,
    src: 'https://readdy.ai/api/search-image?query=Flat%20lay%20of%20various%20garden%20flowers%20top%20down%20view%2C%20white%20roses%20pink%20peonies%20purple%20sweet%20peas%20lavender%20eucalyptus%20on%20white%20marble%20surface%2C%20artistic%20floral%20composition%2C%20soft%20natural%20light%20from%20above%2C%20editorial%20style%20botanical%20photography%2C%20abundance%20and%20luxury&width=700&height=500&seq=bloom-gallery-6&orientation=landscape',
    category: 'Wedding',
    tall: false,
  },
  {
    id: 7,
    src: 'https://readdy.ai/api/search-image?query=Flower%20arrangement%20lesson%20workshop%20hands%20placing%20pink%20roses%20in%20clear%20vase%2C%20florist%20tools%20and%20scattered%20petals%20on%20white%20table%2C%20soft%20blurred%20studio%20background%2C%20learning%20craft%20photography%2C%20warm%20intimate%20atmosphere%2C%20creative%20process%20beauty&width=600&height=750&seq=bloom-gallery-7&orientation=portrait',
    category: 'Lesson',
    tall: true,
  },
  {
    id: 8,
    src: 'https://readdy.ai/api/search-image?query=Beautiful%20seasonal%20flower%20arrangement%20in%20ceramic%20vase%2C%20pink%20and%20cream%20tulips%20with%20anemones%20and%20soft%20greenery%2C%20placed%20on%20kitchen%20counter%20with%20natural%20light%20window%2C%20cozy%20Scandinavian%20home%20lifestyle%20photography%2C%20spring%20flowers%20interior%20styling&width=700&height=500&seq=bloom-gallery-8&orientation=landscape',
    category: 'Interior',
    tall: false,
  },
];

const categories = ['All', 'Bridal', 'Wedding', 'Gift', 'Interior', 'Lesson'];

export default function GallerySection() {
  const [active, setActive] = useState('All');
  const [visible, setVisible] = useState(false);
  const [lightbox, setLightbox] = useState<string | null>(null);
  const ref = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  const filtered = active === 'All' ? galleryItems : galleryItems.filter(i => i.category === active);

  return (
    <section id="gallery" ref={ref} className="py-24 lg:py-36 px-6 lg:px-12 bg-[#faf8f5]">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className={`text-center mb-14 transition-all duration-1000 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <p className="font-noto text-xs tracking-[0.4em] text-[#c4956a] uppercase mb-4">Gallery</p>
          <h2 className="font-cormorant text-5xl lg:text-6xl text-[#2c2218] font-light mb-10">作品ギャラリー</h2>

          {/* Filter tabs */}
          <div className="flex flex-wrap gap-2 justify-center">
            {categories.map(cat => (
              <button
                key={cat}
                onClick={() => setActive(cat)}
                className={`font-noto text-xs tracking-widest px-5 py-2 rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap ${
                  active === cat
                    ? 'bg-[#2c2218] text-[#faf8f5]'
                    : 'bg-white text-[#6b5c4e] border border-[#e8ddd0] hover:border-[#c4956a]'
                }`}
              >
                {cat}
              </button>
            ))}
          </div>
        </div>

        {/* Masonry-style grid */}
        <div className="columns-2 md:columns-3 lg:columns-4 gap-4 space-y-4">
          {filtered.map((item, i) => (
            <div
              key={item.id}
              className={`break-inside-avoid relative group overflow-hidden rounded-lg cursor-pointer transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
              style={{ transitionDelay: `${i * 80}ms` }}
              onClick={() => setLightbox(item.src)}
            >
              <img
                src={item.src}
                alt={item.category}
                className="w-full object-cover group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/25 transition-all duration-300 flex items-center justify-center">
                <div className="w-8 h-8 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <i className="ri-zoom-in-line text-white text-2xl"></i>
                </div>
              </div>
              <span className="absolute bottom-3 left-3 font-noto text-xs tracking-widest text-white/90 bg-black/30 backdrop-blur-sm px-3 py-1 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                {item.category}
              </span>
            </div>
          ))}
        </div>
      </div>

      {/* Lightbox */}
      {lightbox && (
        <div
          className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-4"
          onClick={() => setLightbox(null)}
        >
          <button
            className="absolute top-6 right-6 w-10 h-10 flex items-center justify-center cursor-pointer"
            onClick={() => setLightbox(null)}
          >
            <i className="ri-close-line text-white text-2xl"></i>
          </button>
          <img
            src={lightbox}
            alt="Gallery"
            className="max-w-full max-h-[90vh] object-contain rounded-lg"
            onClick={e => e.stopPropagation()}
          />
        </div>
      )}
    </section>
  );
}
